export type SkillBonusType = "work_efficiency" | "hunt_attack" | "hunt_crit_chance";

export interface SkillTemplate {
  id: number;
  name: string;
  description: string;
  durationMinutes: number;
  requiredLevel: number;
  prerequisiteSkillId: number | null;
  bonusType: SkillBonusType;
  bonusValue: number;
  textbookName: string; // 학습 시작 시 구입하는 교재 (세계관 톤)
  textbookCost: number; // 교재비 (골드) — 학습 시작 시 차감
}

export const SKILL_TEMPLATES: SkillTemplate[] = [
  {
    id: 1,
    name: "HTML 기초",
    description: "모든 것의 시작. div로 시작해서 div로 끝난다.",
    durationMinutes: 30,
    requiredLevel: 1,
    prerequisiteSkillId: null,
    bonusType: "work_efficiency",
    bonusValue: 2,
    textbookName: "생활코딩 제본판",
    textbookCost: 50,
  },
  {
    id: 2,
    name: "CSS 기초",
    description: "가운데 정렬을 할 수 있게 된다. 아마도.",
    durationMinutes: 30,
    requiredLevel: 1,
    prerequisiteSkillId: null,
    bonusType: "work_efficiency",
    bonusValue: 2,
    textbookName: "우리들의 가운데 정렬 대작전",
    textbookCost: 50,
  },
  {
    id: 3,
    name: "Git 입문",
    description: "커밋 메시지는 미래의 나에게 보내는 편지다. \"asdf\"라고 쓰지 말자.",
    durationMinutes: 60,
    requiredLevel: 1,
    prerequisiteSkillId: null,
    bonusType: "hunt_attack",
    bonusValue: 1,
    textbookName: "커밋의 정석: asdf에서 벗어나기",
    textbookCost: 80,
  },
  {
    id: 4,
    name: "JavaScript 핵심",
    description: "undefined is not a function과의 기나긴 싸움이 시작된다.",
    durationMinutes: 240,
    requiredLevel: 2,
    prerequisiteSkillId: 1,
    bonusType: "hunt_attack",
    bonusValue: 2,
    textbookName: "모던 JS의 숲 (안 읽은 티 안 나는 요약본)",
    textbookCost: 150,
  },
  {
    id: 5,
    name: "반응형 디자인",
    description: "대표님 아이폰에서도 버튼이 안 깨지게 된다.",
    durationMinutes: 180,
    requiredLevel: 2,
    prerequisiteSkillId: 2,
    bonusType: "work_efficiency",
    bonusValue: 3,
    textbookName: "대표님 아이폰 대응 실전 가이드",
    textbookCost: 120,
  },
  {
    id: 6,
    name: "DevTools 활용",
    description: "console.log 백만 개 대신 브레이크포인트를 쓰는 법을 배운다.",
    durationMinutes: 120,
    requiredLevel: 3,
    prerequisiteSkillId: 4,
    bonusType: "hunt_crit_chance",
    bonusValue: 3,
    textbookName: "F12를 눌러라",
    textbookCost: 100,
  },
];

export const SKILL_LEARN_STAMINA_COST = 10;

export interface SkillBonuses {
  workEfficiencyPct: number;
  huntAttackFlat: number;
  huntCritChancePct: number;
}

// Sum the bonuses of whichever templates are in `completedSkillIds` — pure,
// so both server-side hunt/work resolution can call it the same way.
export function aggregateSkillBonuses(
  templates: SkillTemplate[], completedSkillIds: Iterable<number>
): SkillBonuses {
  const completed = new Set(completedSkillIds);
  const bonuses: SkillBonuses = { workEfficiencyPct: 0, huntAttackFlat: 0, huntCritChancePct: 0 };
  for (const t of templates) {
    if (!completed.has(t.id)) continue;
    if (t.bonusType === "work_efficiency") bonuses.workEfficiencyPct += t.bonusValue;
    else if (t.bonusType === "hunt_attack") bonuses.huntAttackFlat += t.bonusValue;
    else if (t.bonusType === "hunt_crit_chance") bonuses.huntCritChancePct += t.bonusValue;
  }
  return bonuses;
}
